export const API_URL = 'https://schedule.guap.ru:4444'
